export enum PhotographerRole {
    //BASICSTUDIOS_ADMIN = 'basicstudios-admin',
    DASHBOARD_READ = 'photographer-dashboard-read',
    SHOOTINGLIST_READ = 'photographer-shootinglist-read',
    ORDERLIST_READ = 'photographer-orderlist-read',
    ORDERLIST_EDIT = 'photographer-orderlist-edit',
    GETHIRED_READ = 'photographer-gethired-read',
    MANAGEMENT_READ = 'photographer-management-read',
    ACCOUNT_READ = 'photographer-account-read'
}